/**
 * Gutenberg Block JS
 *
 * Import JS for Gutenberg blocks.
 */

// Custom Gutenberg Blocks.
// import './wd';
import './video';
import './faq';
import './course-content';
import './testimonials';
import './partners';
import './list-of-articles';
import './repeater-content-image';
import './testimonials-slider';
